import React from 'react';
import { buildSalaryObject } from './transform';
export var Salary = function Salary(props) {
  var salary = buildSalaryObject(props);
  var range = salary.range,
      currency = salary.currency,
      period = salary.period,
      description = salary.description;
  var details;

  if (!description && !range) {
    details = /*#__PURE__*/React.createElement("em", null, "Undisclosed");
  } else if (range) {
    details = /*#__PURE__*/React.createElement("span", null, currency.code, " ", /*#__PURE__*/React.createElement("b", null, range), " ", period, " ", description && /*#__PURE__*/React.createElement("span", null, "(", description, ")"));
  } else {
    details = /*#__PURE__*/React.createElement("span", null, description);
  }

  return /*#__PURE__*/React.createElement("span", {
    className: "tds-salary"
  }, " ", details, " ");
};
Salary.displayName = "Salary";